module.exports = __webpack_public_path__ + "static/media/6-custom-cut-mat-board-online-delivery-service-canada-and-usa.48cf5ce9.webp";